/*
 * Copyright (c) 2025 Bytedance, Inc. and its affiliates.
 * SPDX-License-Identifier: Apache-2.0
 */

import { ConsoleLogger } from '@agent-infra/logger';

export const logger = new ConsoleLogger('[AgentSnapshot]');
